import * as FromReport from "src/app/store/report/selectors";
import * as FromSurvey from "src/app/store/survey/selectors";
import { Pipe, PipeTransform } from "@angular/core";
import { ReportDto, SurveyDefinitionDto } from "@api";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { map, withLatestFrom } from "rxjs/operators";
import { RootState } from "src/app/store";
import { kebabCaseToMacroCase } from "src/app/utils/kebab-case-to-macro-case";
import { IsValidReportPipe } from "../is-valid-report/is-valid-report.pipe";

@Pipe({ name: "isReportFilled" })
export class IsReportFilledPipe implements PipeTransform {
  constructor(private store: Store<RootState>, private isvalidReportPipe: IsValidReportPipe) {}

  public transform(date: Date, definition: SurveyDefinitionDto, slug: string): Observable<"FULL" | "PARTIAL" | "EMPTY"> {
    return this.store
      .select(
        FromReport.selectReportsForDate(kebabCaseToMacroCase(slug) as ReportDto.DataSourceEnum, date.getMonth() + 1, date.getFullYear()),
      )
      .pipe(
        withLatestFrom(this.store.select(FromSurvey.selectDefinitionFieldsBySlug(definition?.slug))),
        map(([reports, fields]) => reports.filter(report => fields.some(field => field.dataDefinitionId === report.dataDefinitionId))),
        map(reports => {
          if (!reports?.length || !definition) return "EMPTY";
          if (this.isvalidReportPipe.transform(definition.surveyFields, reports)) return "FULL";
          return "PARTIAL";
        }),
      );
  }
}
